import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

// Cache-Buster
const addCacheBuster = (path) => {
  if (!path) return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}t=${Date.now()}`;
};

const Welcome = () => {
  const { t } = useLanguage();
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && showVideoModal) {
      videoRef.current.volume = 0.25;
    }
  }, [showVideoModal]);

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="mb-8">
            <img
              src={addCacheBuster('/images/logo.webp')}
              alt="Svansele Grönt"
              className="w-64 h-48 object-cover rounded-lg mx-auto shadow-lg"
            />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            {t('welcome.title')}
          </h2>
          <p className="text-xl text-accent-green italic mb-8">
            {t('welcome.subtitle')}
          </p>
          <Link
            to="/marknader?focus=farmshop"
            className="btn-custom-outline px-8 py-3 rounded-lg font-semibold border-2 inline-block"
          >
            {t('welcome.findUsBtn')}
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h3 className="text-xl font-semibold mb-4">
            {t('welcome.ecologicalTitle')}
          </h3>
          <p className="text-gray-600 mb-6">
            {t('welcome.hopeSee')}
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
            <button
              onClick={() => {
                setSelectedVideo('/videos/Sauerkraut_gott_och_nyttigt.mp4');
                setShowVideoModal(true);
              }}
              className="block w-full cursor-pointer"
            >
              <img
                src={addCacheBuster('/images/inteDumt.png')}
                alt="Sauerkraut Video"
                className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg hover-scale transition-transform duration-300 hover:scale-105"
              />
            </button>
            <button
              onClick={() => {
                setSelectedVideo('/videos/morotsjoos_short.mp4');
                setShowVideoModal(true);
              }}
              className="block w-full cursor-pointer"
            >
              <img
                src={addCacheBuster('/images/morotsjoos_final.png')}
                alt="Morotsjoos Video"
                className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg hover-scale transition-transform duration-300 hover:scale-105"
              />
            </button>
            <img
              src={addCacheBuster('/images/hallo.webp')}
              alt={t('welcome.cafeVisitors')}
              className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg hover-scale"
            />
            <button
              onClick={() => {
                setSelectedVideo('/videos/morotsskoerd_v_1.webm');
                setShowVideoModal(true);
              }}
              className="block w-full cursor-pointer"
            >
              <img
                src={addCacheBuster('/images/morostsskoerd_1.webp')}
                alt="Morotsskörd"
                className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg hover-scale transition-transform duration-300 hover:scale-105"
              />
            </button>
          </div>

          {showVideoModal && (
            <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4" onClick={() => setShowVideoModal(false)}>
              <div className="relative flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
                <video
                  ref={videoRef}
                  src={addCacheBuster(selectedVideo)}
                  className="w-full h-auto max-h-screen rounded-lg shadow-lg"
                  controls
                  autoPlay
                />
                <button
                  onClick={() => setShowVideoModal(false)}
                  className="absolute top-4 right-4 bg-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-black hover:bg-gray-200"
                >
                  ✕
                </button>
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default Welcome;